<template>
  <div class="attendance-page">
    <div v-if="totalPage <= 1" class="monthly-title">[{{ month }}]월 출근부</div>
    <div v-else class="monthly-title">[{{ month }}]월 출근부 <span class="subheading">(p{{ currentPage }})</span></div>
    <div class="monthly-subheader">행복충전소</div>
    <table class="attendance-header-table">
      <tbody>
        <tr>
          <th>성명</th>
          <td> {{ checker.name }}</td>
          <th>생년월일</th>
          <td>{{ checker.birthDate }}</td>
        </tr>
        <tr>
          <th>채용일자</th>
          <td>{{ checker.hireDate }}</td>
          <th>연락처</th>
          <td>{{ phoneNumber }}</td>
        </tr>
        <tr>
          <th>주소</th>
          <td colspan="3">{{ checker.address }}</td>
        </tr>
      </tbody>
    </table>

    <table class="attendance-body-table">
      <thead>
        <tr>
          <th>요일</th>
          <th class="sunday">일</th>
          <th>월</th>
          <th>화</th>
          <th>수</th>
          <th>목</th>
          <th>금</th>
          <th class="saturday">토</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, rowIndex) in rows">
          <template v-if="rowIndex == 5">
            <tr class="date-row" :key="`head-${rowIndex}`">
              <th>날짜</th>
              <th v-for="(cell, cellIndex) in [row[0], row[1]]"
                  :key="`head-row-${rowIndex}-cell-${cellIndex}`"
                  class="date-head-cell">
                <template v-if="cell.head.date">
                  <div class="head-content">
                    <span :class="{'holiday': isHoliday(cell.head.date)}">{{ cell.head.date }}
                      <v-icon
                        v-if="cellEditable(cell, cellIndex)" size="10"
                        class="ml-1 no-print"
                        @click="onDateEditClick(cell)">
                        edit
                      </v-icon>
                    </span>
                    <span>{{ cell.head.duration }}</span>
                  </div>
                </template>
              </th>
              <th colspan="5">
                근 무 지
              </th>
            </tr>
            <tr class="data-row" :key="`data-${rowIndex}`">
              <td></td>
              <td v-for="(cell, cellIndex) in [row[0], row[1]]"
                :key="`data-row-${rowIndex}-cell-${cellIndex}`">

                <daily-item class="attendance-daily-item"
                  :total-page="totalPage"
                  :current-page="currentPage"
                  :attend="{
                    ...cell.attend,
                    attends: pagedAttends(cell)
                  }">
                </daily-item>
              </td>
              <td colspan="5" class="places">
                <template v-if="chargerAliases.length <= 4">
                  <div
                    v-for="(alias, placeIndex) in chargerAliases"
                    :key="placeIndex"
                  >
                    {{ alias }}
                  </div>
                </template>
                <v-layout v-else row wrap>
                  <!-- 왼쪽 컬럼 -->
                  <v-flex xs6>
                    <div
                      v-for="(alias, i) in leftAliases"
                      :key="'l-' + i"
                    >
                      {{ alias }}
                    </div>
                  </v-flex>

                  <!-- 오른쪽 컬럼 -->
                  <v-flex xs6>
                    <div
                      v-for="(alias, i) in rightAliases"
                      :key="'r-' + i"
                    >
                      {{ alias }}
                    </div>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr class="date-row" :key="`head-${rowIndex}`">
              <th>날짜</th>
              <th v-for="(cell, cellIndex) in row"
                :key="`head-row-${rowIndex}-cell-${cellIndex}`"
                :class="{
                  'date-head-cell': true,
                  'holiday': isHoliday(cell.head.date),
                  'sunday': cellIndex === 0,
                  'saturday': cellIndex === 6
                }">
                <template v-if="cell.head.date">
                  <div class="head-content">
                    <span>{{ cell.head.date }}
                      <v-icon
                        v-if="cellEditable(cell, cellIndex)" size="10"
                        class="ml-1 no-print"
                        @click="onDateEditClick(cell)">
                        edit
                      </v-icon>
                    </span>
                    <span>{{ cell.head.duration }}</span>
                  </div>
                </template>
              </th>
            </tr>
            <tr class="data-row" :key="`data-${rowIndex}`">
              <td></td>
              <td v-for="(cell, cellIndex) in row"
                :key="`data-row-${rowIndex}-cell-${cellIndex}`">

                <daily-item class="attendance-daily-item"
                  :total-page="totalPage"
                  :current-page="currentPage"
                  :attend="{
                    ...cell.attend,
                    attends: pagedAttends(cell)
                  }">
                </daily-item>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

    <table class="attendance-footer-table">
      <thead>
        <tr>
          <th colspan="4">근 무 상 황</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>연차, 병가, 공가</th>
          <td>{{ nonWorkSummary }}</td>
          <th>휴가, 지각, 조퇴, 외출, 결근</th>
          <td>{{ timeAffectSummary }}</td>
        </tr>
        <tr>
          <th style="width: 20%">근무일수</th>
          <th style="width: 30%">{{ workDaysCount }} 일</th>
          <th style="width: 25%">근무시간</th>
          <th style="width: 25%">{{ workHours }} 시간</th>
        </tr>
        <tr>
          <td>수행기관</td>
          <td>(사)대전지체장애인협회</td>
          <td colspan="2">
            <table>
              <tr style="border: 0px; !important">
                <td style="width: 40%; border: 0px; !important; border-right: 1px solid black">담당자</td>
                <td style="width: 60%; border: 0px; !important"><span style="letter-spacing: 0.5em;">{{ displayName }}</span>(인)</td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import DailyItem from './DailyItem'
import {Util} from '../../Util'
import '@/assets/css/AttendanceDocument.css'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

export default {
  components: {
    'daily-item': DailyItem
  },
  props: {
    checker: {
      type: Object,
      default: () => ({})
    },
    placeAliases: {
      type: Array,
      default: () => ([])
    },
    chargerAliases: {
      type: Array,
      default: () => ([])
    },
    reports: {
      type: Array,
      default () {
        return []
      }
    },
    attends: {
      type: Array,
      default () {
        return []
      }
    },
    yearMonth: {
      type: String,
      default () {
        return moment().startOf('month').format('YYYY-MM')
      }
    },
    restDayItems: {
      type: Array,
      default: () => []
    },
    totalPage: {
      type: Number,
      default: () => 0
    },
    currentPage: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      // cells: new Array(7 * 5)
      selectedCell: null,
      displayName: ''
    }
  },
  computed: {
    phoneNumber () {
      return this.checker && this.checker.phoneNumber ? Util.phoneNumberFormat(this.checker.phoneNumber, true, false) : ''
    },
    month () {
      return moment(this.yearMonth).startOf('month').format('M')
    },
    // convert the list of reports into a map of lists keyed by date
    reportsMap () {
      const map = {}
      this.reports.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      return map
    },
    cells () {
      let cells = new Array(7 * 6)
      cells.fill({head: {date: '', duration: ''}, attends: [], reports: []})

      let day = moment(this.yearMonth).startOf('month')
      let daysOfMonth = day.daysInMonth()
      let start = day.weekday()
      let end = daysOfMonth + day.weekday()

      for (let i = start; i < end; i++) {
        // console.log('day', day.format('YYYY-MM-DD'), day.weekday())

        cells[i] = {
          head: {date: day.format('D'), duration: ''},
          attend: null,
          reports: []
        }

        if (this.attends) { // custom attends 가 있으면 merge
          const attend = this.attends.find(a => a.date === day.format('YYYY-MM-DD'))
          if (attend) {
            let sortedAttends = []

            if (attend.attends) {
              // attend.attends.sort((a, b) => a.time.localeCompare(b.time))
              // 원본 배열을 복사한 후 정렬
              sortedAttends = [...attend.attends].sort((a, b) =>
                a.time.localeCompare(b.time)
              )
            }
            // cells[i].attend = attend
            cells[i].attend = {
              ...attend,
              attends: sortedAttends
            }
          }
        }

        let reports = this.reportsMap[day.format('YYYY-MM-DD')]
        cells[i].reports = reports || []

        if (reports && !cells[i].attend) { // custom attends 가 없으면 report 에서 merge
          const tempAttend = reports.map(item => {
            const t = moment(item.created.toDate()).format('HH:mm')
            return { time: t, place: item.place.name }
          })

          tempAttend.sort((a, b) => a.time.localeCompare(b.time))
          // cells[i].attend = {
          //   workType: tempAttend.length > 0 ? 'WORK' : cells[i].attend.workType,
          //   ...cells[i].attend,
          //   attends: tempAttend
          // }
          cells[i].attend = {
            workType: tempAttend.length > 0 ? 'WORK' : (cells[i].attend.workType || ''),
            ...(cells[i].attend || {}),
            attends: [...tempAttend] // 복사
          }
        }

        if (cells[i].attend) {
          cells[i].head.duration = this.getDuration(cells[i].attend.attends)
        }

        day = day.add(1, 'day')
      }

      // console.log(cells)
      return cells
    },
    rows () {
      return [
        this.cells.slice(0, 7),
        this.cells.slice(7, 14),
        this.cells.slice(14, 21),
        this.cells.slice(21, 28),
        this.cells.slice(28, 35),
        this.cells.slice(35, 42)
      ]
    },
    nonWorkSummary () {
      const c0 = this.attends.filter(
        a => a.workType === 'NON_WORK' && a.status === 'ANNUAL_LEAVE'
      ).length

      const c1 = this.attends.filter(
        a => a.workType === 'NON_WORK' && a.status === 'PUBLIC_LEAVE'
      ).length

      const c2 = this.attends.filter(
        a => a.workType === 'NON_WORK' && a.status === 'SICK_LEAVE'
      ).length

      const parts = []

      parts.push(`연차: ${c0 || ''}일`)
      parts.push(`공가: ${c1 || ''}일`)
      if (c2 > 0) parts.push(`병가: ${c2}일`)

      return parts.join(' / ')
    },
    timeAffectSummary () {
      const c0 = this.attends.filter(
        a => a.workType === 'NON_WORK' && a.status === 'SPECIAL_LEAVE'
      ).length

      const c1 = this.attends.filter(
        a => a.workType === 'NON_WORK' && a.status === 'ABSENT'
      ).length

      const c2 = this.attends.filter(
        a => a.workType === 'TIME_AFFECT' && (a.status === 'LATE' || a.timeAffects.filter(t => t.type === 'LATE').length > 0)
      ).length

      const c3 = this.attends.filter(
        a => a.workType === 'TIME_AFFECT' && (a.status === 'EARLY_LEAVE' || a.timeAffects.filter(t => t.type === 'EARLY_LEAVE').length > 0)
      ).length

      const c4 = this.attends.filter(
        a => a.workType === 'TIME_AFFECT' && a.status === 'OUT'
      ).length

      const parts = []

      if (c0 > 0) parts.push(`휴가: ${c0}`)
      if (c1 > 0) parts.push(`결근: ${c1}`)
      if (c2 > 0) parts.push(`지각: ${c2}`)
      if (c3 > 0) parts.push(`조퇴: ${c3}`)
      if (c4 > 0) parts.push(`외출: ${c4}`)

      return parts.join(' / ')
    },
    workDaysCount () {
      const c0 = this.cells.filter(
        cell => cell.attend &&
        (
          cell.attend.workType === 'WORK' ||
          (cell.attend.workType === 'NON_WORK' && ['ANNUAL_LEAVE', 'SICK_LEAVE', 'PUBLIC_LEAVE'].includes(cell.attend.status)) ||
          (!cell.attend.workType && cell.attend.attends.length > 0)
        )
      ).length

      return c0
    },
    workHours () {
      // return this.workDaysCount * 3
      // return 60
      if (this.workDaysCount >= 16) {
        return 60
      } else if (this.workDaysCount >= 12) {
        return 45
      } else if (this.workDaysCount >= 8) {
        return 30
      } else if (this.workDaysCount >= 4) {
        return 15
      }
    },
    leftAliases () {
      const half = Math.ceil(this.chargerAliases.length / 2)
      return this.chargerAliases.slice(0, half)
    },
    rightAliases () {
      const half = Math.ceil(this.chargerAliases.length / 2)
      return this.chargerAliases.slice(half)
    }
  },
  created () {
    // console.log(this.reports)
    // console.log(this.yearMonth)
    this.getUserInfo()
  },
  methods: {
    onDateEditClick (cell) {
      // console.log(cell)
      this.selectedCell = cell
      this.$emit('cellEditClick', cell)
    },
    getUserInfo () {
      var user = firebase.auth().currentUser

      if (user != null) {
        this.displayName = user.displayName
      }
    },
    getDuration (attends) {
      if (!attends || attends.length === 0) {
        return ''
      }

      const toMin = (str) => {
        const [h, m] = str.split(':').map(Number)
        return h * 60 + m
      }

      const first = attends[0].time
      const last = attends[attends.length - 1].time

      const diff = toMin(last) - toMin(first)

      if (diff >= 0) {
        const h = Math.floor(diff / 60)
        const m = diff % 60
        return `${h}h ${m}m`
      }
    },
    isHoliday (d) {
      const day = String(d).padStart(2, '0')
      const date = `${this.yearMonth}${day}`.replaceAll('-', '')

      if (this.restDayItems && this.restDayItems.length > 0) {
        // open data 의 날짜는 문자열 아닌 int 임
        return this.restDayItems.some(d => (d.locdate.toString() === date) && d.isHoliday === 'Y')
      }

      return null
    },
    isFuture (d) {
      const day = String(d).padStart(2, '0')
      const date = `${this.yearMonth}${day}`.replaceAll('-', '')

      return moment(date, 'YYYYMMDD').isAfter(moment(), 'day')
    },
    cellEditable (cell, cellIndex) {
      if (!this.checker || this.currentPage > 1) { // 첫 페이지에서만 수정 가능함
        return false
      }

      const day = String(cell.head.date).padStart(2, '0')
      const date = `${this.yearMonth}${day}`.replaceAll('-', '')
      const target = moment(date, 'YYYYMMDD')

      // ✅ 오늘 기준 "두 달 전"의 '1일'
      const editableFrom = moment()
        .subtract(2, 'months')
        .startOf('month')

      // 미래 날짜는 불가
      const isNotFuture = !target.isAfter(moment(), 'day')

      // 기준일 이후만 허용
      const isAfterBaseDate = target.isSameOrAfter(editableFrom, 'day')

      return isAfterBaseDate &&
        isNotFuture &&
        (
          (cellIndex > 0 && cellIndex < 6) ||
          !!cell.attend
        )
    },
    pagedAttends (cell) {
      if (!cell || !cell.attend || !cell.attend.attends) return []

      if (cell && cell.attend.workType === 'TIME_AFFECT') {
        // const lates = cell.attend.timeAffects.filter(t => t.type === 'LATE')
        // const eaalyLeaves = cell.attend.timeAffects.filter(t => t.type === 'EARLY_LEAVE')

        const DAILY_MAX = 4
        const start = (this.currentPage - 1) * DAILY_MAX
        const end = start + DAILY_MAX

        return cell.attend.attends.slice(start, end)
      } else {
        const DAILY_MAX = 5
        const start = (this.currentPage - 1) * DAILY_MAX
        const end = start + DAILY_MAX

        return cell.attend.attends.slice(start, end)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Report/Attendance/MonthlyPage.vue